import Joi from 'joi';

const ValidationData = Joi.string().required();

export default ValidationData;
